module.exports = __webpack_public_path__ + "img/discussions.8f45a85d.svg";